import { createSelector } from 'reselect'
import getMusclesWorkedStrByIdExerciseSelector from 'modules/exercise/redux/selectors/get-muscles-worked-str-by-id/index.js'
import getEquipmentStrByIdExerciseSelector from 'modules/exercise/redux/selectors/get-equipment-str-by-id/index.js'
import getDescriptionByIdExerciseSelectorUtil from 'modules/exercise/redux/selectors/get-description-by-id/utils/index.js'

/**
 * @param props
 * @param props.id
 * @param props.intl
 * @param props.isShort
 */
function getDescriptionByIdExerciseSelector ({
  id,
  intl,
  isShort
}) {
  return createSelector(
    getMusclesWorkedStrByIdExerciseSelector({
      id,
      intl
    }),
    getEquipmentStrByIdExerciseSelector({
      id,
      intl,
      isShort
    }),
    (
      musclesWorkedStr,
      equipmentStr
    ) => getDescriptionByIdExerciseSelectorUtil({
      musclesWorkedStr,
      equipmentStr
    })
  )
}

export default getDescriptionByIdExerciseSelector
